export default function SafetyHarborAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Safety Harbor Post Office",
      address: "323 Main St, Safety Harbor, FL 34695",
      phone: "(727) 725-1561",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM; Sat: 9:00 AM – 12:00 PM",
      notes: "Accepts passport applications by appointment. Limited Saturday hours.",
    },
    {
      name: "Clearwater Main Post Office",
      address: "1000 Cleveland St, Clearwater, FL 33755",
      phone: "(727) 443-1553",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      notes: "Full-service passport acceptance facility. Appointments recommended but walk-ins accepted when capacity allows.",
    },
    {
      name: "Palm Harbor Post Office",
      address: "34980 US Hwy 19 N, Palm Harbor, FL 34684",
      phone: "(727) 784-0437",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      notes: "Accepts passport applications by appointment. Large facility serving northern Pinellas County.",
    },
    {
      name: "Dunedin Post Office",
      address: "729 Highland Ave, Dunedin, FL 34698",
      phone: "(727) 733-2166",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      notes: "Passport acceptance by appointment. Convenient for Dunedin and southern Safety Harbor residents.",
    },
    {
      name: "Largo Post Office",
      address: "1000 Bellaire Blvd, Largo, FL 33770",
      phone: "(727) 585-1238",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      notes: "Accepts passport applications by appointment. Large facility serving central Pinellas County.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Safety Harbor
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            If you need a first-time passport or a child passport, you must visit an acceptance facility with your documents. These are the closest passport acceptance facilities to Safety Harbor.
          </p>
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
              <i className="ri-information-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <p className="text-white font-bold text-sm mb-1">Important: What Acceptance Facilities Do (and Don't Do)</p>
              <p className="text-white/70 text-sm leading-relaxed">
                Acceptance facilities (USPS offices, libraries, and clerk offices) do <strong className="text-white">not</strong> process or print passports on-site. They verify your identity, witness your signature on Form DS-11, and send your application to the National Passport Processing Center. Processing takes <strong className="text-white">7–11 weeks for routine service</strong> or <strong className="text-white">3–5 weeks for expedited mail-in service</strong> — too slow for most travelers with upcoming trips.
              </p>
              <p className="text-white/70 text-sm leading-relaxed mt-2">
                For faster processing, <a href="https://fastpassportcenter.com/checkout/" className="text-[#F6C344] font-semibold hover:underline">Fast Passport Center</a> submits your application directly to a regional passport agency using our registered courier status — bypassing the routine queue entirely.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {facilities.map((f, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 p-6 hover:border-[#F6C344] transition-all duration-200"
            >
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1A365D]/10 flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-sm"></i>
                    </div>
                    <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  </div>
                  <p className="text-gray-500 text-sm ml-10 mb-1">
                    <i className="ri-map-pin-line text-gray-400 mr-1 text-xs"></i>
                    {f.address}
                  </p>
                  <p className="text-gray-500 text-sm ml-10 mb-1">
                    <i className="ri-phone-line text-gray-400 mr-1 text-xs"></i>
                    {f.phone}
                  </p>
                  <p className="text-gray-500 text-sm ml-10">
                    <i className="ri-time-line text-gray-400 mr-1 text-xs"></i>
                    {f.hours}
                  </p>
                </div>
                <div className="md:w-72 flex-shrink-0">
                  <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                    <p className="text-amber-800 text-xs leading-relaxed">
                      <i className="ri-alert-line text-amber-500 mr-1"></i>
                      {f.notes}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}